// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useState } from 'react'
import moment from 'moment/moment'
import { useDispatch, useSelector } from 'react-redux'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { DrugScreenTag, IdVerificationStatusTag } from 'ui_kit_qmd'
import voidPhoto from '../../../../../images/waitingRoom/voidPhoto.png'
import {
  getAge,
  getStateByAbbreviation,
  getTabId,
  isDrugScreenTagClickable,
  isIDVerificationClickable,
} from '../../../../../utils/common'
import errorIcon from '../../../../../images/common/error-icon.svg'
import editAllergiesIcon from '../../../../../images/charts/editAllergiesIcon.png'
import { AllergiesHoverOverPopUp } from '../../../../../components/AllergiesHoverOverPopUp/AllergiesHoverOverPopUp'

import './PatientInfoTile.scss'
import { getMediaFile } from '../../../../../store/file-pop-up/FilePopUpThunk'
import { getIDVerification } from '../../../../../store/id-verification-pop-up/IDVerificationPopUpThunk'
import { PdmpInfo } from 'pages/charts/patient-chart/components/patient-info-tile/components/PdmpInfo'
import { selectPdmpPilotEnabled } from 'store/flags/FlagsSelectors'
import { ProgramPlanBadge } from 'components/program-plan-badge/ProgramPlanBadge'

const patientChartToolTipPopUpStyle = {
  top: '90%',
  left: '0%',
}

// @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
const PatientInfoTile = memo(({ restrictionStatus, isShowNamesPopUp, allergiesCount, onIsAllergiesPopUpOpened }) => {
  const params = new URLSearchParams(window.location.search)
  const id = params.get('id')
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const patientInfo = useSelector((state) => state.chartsReducer.patientInfo?.[id] || {})
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const flags = useSelector((state) => state.flags.flags)

  const tabId = getTabId()
  const dispatch = useDispatch()

  const { CompleteDate, ExpireDate, Status } = patientInfo?.DrugScreen || {}

  const [isOnHoverShowNamesPopUp, setIsOnHoverShowNamesPopUp] = useState(false)
  const [isAllergiesHoverOverPopUpOpened, setIsAllergiesHoverOverPopUpOpened] = useState(false)

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOverHandler = (type) => {
    switch (type) {
      case 'firstLastName': {
        setIsOnHoverShowNamesPopUp(true)
        break
      }
      default:
        break
    }
  }

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onOpenCloseAllergiesHoverOverPopUp = (type, e) => {
    switch (type) {
      case 'open':
        if (e.target.id === 'editAllergiesBtn') {
          break
        } else {
          setIsAllergiesHoverOverPopUpOpened(true)
          break
        }
      case 'close':
        setIsAllergiesHoverOverPopUpOpened(false)
        break
      default:
        break
    }
  }
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOutHandler = (type) => {
    switch (type) {
      case 'firstLastName': {
        setIsOnHoverShowNamesPopUp(false)
        break
      }
      default:
        break
    }
  }
  const getFile = useCallback(() => {
    dispatch(getMediaFile({ ...patientInfo, StateCode: patientInfo?.Address?.StateCode }, tabId))
  }, [patientInfo, patientInfo?.Address])

  const getIDVerificationInfo = useCallback(() => {
    dispatch(getIDVerification(id, tabId))
  }, [dispatch, tabId, id])

  const pdmpPilotEnabled = useSelector(selectPdmpPilotEnabled)

  return (
    <div className='patient_chart-patient_info_title-container'>
      <div className='patient_chart-patient_profile_img-wrapper'>
        <img
          className='patient_chart-patient_profile_img'
          src={patientInfo?.ImageUrl ?? voidPhoto}
          alt='patientPhoto'
        />
      </div>
      <div className='patient-chart-title-block'>
        <div className='FirstLastNameWithToolTip'>
          <div
            id='FirstLastChartPatientName'
            onMouseOver={() => onMouseOverHandler('firstLastName')}
            onMouseLeave={() => onMouseOutHandler('firstLastName')}
            onFocus={() => onMouseOverHandler('firstLastName')}
            onBlur={() => onMouseOutHandler('firstLastName')}
            className='FullNameBlock'>
            <div />
            {patientInfo?.FirstName} {patientInfo?.LastName}
          </div>
          <div className='patient-chart-gender-block'>
            ({patientInfo ? getAge(moment(patientInfo?.BirthDate).toString()) : null}/
            {patientInfo.Gender === 'male' ? 'M' : 'F'})
          </div>
          {isOnHoverShowNamesPopUp && isShowNamesPopUp ?
            <div className='firstLastNameBlockChartTip' style={patientChartToolTipPopUpStyle}>
              {patientInfo?.FirstName} {patientInfo?.LastName}
            </div>
          : null}
        </div>
        <div className='IdInfoTitleBlock'>
          {flags.id_verification_show_tag_provider && patientInfo?.IdentityVerification?.Status ?
            <IdVerificationStatusTag
              tagStatus={patientInfo.IdentityVerification.Status}
              onClick={
                isIDVerificationClickable(patientInfo.IdentityVerification.Status) ? getIDVerificationInfo : null
              }
              requestDateTime={patientInfo.IdentityVerification.RequestDateTime}
            />
          : null}
          {patientInfo?.DrugScreen ?
            <DrugScreenTag
              type={Status}
              completedDate={CompleteDate}
              expiredDate={ExpireDate}
              onClick={isDrugScreenTagClickable(Status) ? getFile : null}
            />
          : null}
          {/* Gates itself on the flag and on the patient holding a usable plan, so it
              sits beside the other status tags with no guard of its own. `.IdInfoTitleBlock`
              is a flex row with `gap: 8px`, so the spacing is already there — unlike
              admin's tag row, which has no gap and pays for it at the call site. */}
          <ProgramPlanBadge patientId={id} />
        </div>

        <div className='additionalInfoTitleBlock'>
          <div>
            <span className='patient-info-label'>Preferred name: </span>
            <span className='patient-info-value'>{patientInfo?.PreferredName || '--'}</span>
          </div>
          <div>
            <span className='patient-info-label'>MRN:</span>
            <span className='patient-info-value'>{patientInfo?.MedicalRecordNumber || '--'}</span>
          </div>
          <div>
            <span className='patient-info-label'>State:</span>
            <span className='patient-info-value'>
              {patientInfo?.Address ? getStateByAbbreviation(patientInfo?.Address?.StateCode?.toUpperCase()) : '--'}
            </span>
          </div>
          <div>
            <span className='patient-info-label'>Date of Birth:</span>

            <span className='patient-info-value'>
              {patientInfo?.BirthDate ? moment(patientInfo?.BirthDate).format('MM/DD/YYYY') : '--'}
            </span>
          </div>
          {pdmpPilotEnabled ?
            <PdmpInfo />
          : null}
          <div
            className='allergies-title-block'
            onMouseOver={(e) => onOpenCloseAllergiesHoverOverPopUp('open', e)}
            onFocus={(e) => onOpenCloseAllergiesHoverOverPopUp('open', e)}
            onMouseLeave={(e) => onOpenCloseAllergiesHoverOverPopUp('close', e)}
            onBlur={(e) => onOpenCloseAllergiesHoverOverPopUp('close', e)}>
            {!!Number(allergiesCount) && <img className='error-chart-allergies-img' src={errorIcon} alt='errorIcon' />}
            <span className='patient-info-label'>Allergies:</span>
            <span className='patient-info-value'>{allergiesCount}</span>
            <img
              className='edit-allergies-icon'
              onClick={() => onIsAllergiesPopUpOpened(true)}
              src={editAllergiesIcon}
              alt='edit allergies'
              id='editAllergiesBtn'
              role='presentation'
            />
            {isAllergiesHoverOverPopUpOpened ?
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              <AllergiesHoverOverPopUp patientInfo={patientInfo} />
            : null}
          </div>
          <div className='allergies-title-block'>
            {restrictionStatus !== 'Compliant' && (
              <img className='error-chart-allergies-img' src={errorIcon} alt='errorIcon' />
            )}
            <span className='patient-info-label'>On hold status:</span>
            <span className='patient-info-value'>{restrictionStatus}</span>
          </div>
        </div>
      </div>
    </div>
  )
})

export default PatientInfoTile
